// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCustomerList } from "../../redux/actions/customerActions";
// import DashboardLayout from "../../Pages/dashboard/DashboardLayout";
// const CustomerList = () => {
//   const dispatch = useDispatch();
//   const { userInfo } = useSelector((state) => state.auth);
//   const { customers, loading, error } = useSelector(
//     (state) => state.fetchCustomerList
//   );

//   useEffect(() => {
//     if (userInfo?.access_token) {
//       dispatch(fetchCustomerList(userInfo.access_token));
//     }
//   }, [dispatch, userInfo]);
//   return (
//     <DashboardLayout>
//       <div className="p-4">
//         <h1 className="text-2xl text-indigo-600 text-center font-bold mb-4">
//         Reeddemed Customer 
//         </h1>
//         {loading ? (
//           <p>Loading...</p>
//         ) : error ? (
//           <p className="text-red-500">{error}</p>
//         ) : (
//           <div className="overflow-x-auto shadow rounded">
//             <table className="w-full text-sm text-left border-collapse">
//               <thead className="border-b border-primary py-14 uppercase tracking-wider">
//                 <tr className="bg-gray-100">
//                   <th className="py-2 px-4 border bg-primary">Customer</th>
//                   <th className="py-2 px-4 border bg-primary">Mobile</th>
//                   <th className="py-2 px-4 border bg-primary">QR Code</th>
//                   <th className="py-2 px-4 border bg-primary">Amount</th>
//                   <th className="py-2 px-4 border bg-primary">City</th>
//                   <th className="py-2 px-4 border bg-primary">State</th>
//                   <th className="py-2 px-4 border bg-primary">Status</th>
//                   <th className="py-2 px-4 border bg-primary">Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {customers.map((c) => (
//                   <tr
//                     key={c.redemption_id}
//                     className="border-t bg-white border-b "
//                   >
//                     <td className="py-4 px-4">{c.customer_name}</td>
//                     <td className="py-4 px-4">{c.mobile}</td>
//                     <td className="py-4 px-4">{c.qr_id}</td>
//                     <td className="py-4 px-4">{c.qr_amount}</td>
//                     <td className="py-4 px-4">{c.city}</td>
//                     <td className="py-4 px-4">{c.state}</td>
//                     <td className="py-2 px-4">
//                       {c.is_successful
//                         ? "Success"
//                         : c.is_failed
//                         ? "Failed"
//                         : "Pending"}
//                     </td>
//                     <td className="py-2 px-4">
//                       {new Date(c.redeemed_at).toLocaleString()}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// };

// export default CustomerList;

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchCustomerList } from "../../redux/actions/customerActions";
import DashboardLayout from "../../Pages/dashboard/DashboardLayout";

const CustomerList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.auth);
  const { customers, loading, error } = useSelector(
    (state) => state.fetchCustomerList
  );

  // Fetch customer list on mount and when timestamp changes (navigation from QRScanner)
  useEffect(() => {
    console.log("CustomerList useEffect triggered", {
      hasToken: !!userInfo?.access_token,
      timestamp: location.state?.timestamp,
    });
    
    if (userInfo?.access_token) {
      dispatch(fetchCustomerList(userInfo.access_token));
    }
  }, [dispatch, userInfo, location.state?.timestamp]); // Added location.state?.timestamp

  // Manual refresh function
  const handleRefresh = () => {
    if (userInfo?.access_token) {
      dispatch(fetchCustomerList(userInfo.access_token));
    }
  };

  // Check if customers is an array
  const customersList = Array.isArray(customers) ? customers : [];

  console.log("CustomerList render:", {
    loading,
    error,
    customersCount: customersList.length,
    customers: customersList,
  });

  return (
    <DashboardLayout>
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl text-indigo-600 font-bold">
            Redeemed Customer
          </h1>
          <button
            onClick={handleRefresh}
            disabled={loading}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {loading ? (
              <>
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Refreshing...
              </>
            ) : (
              <>
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                Refresh
              </>
            )}
          </button>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-12">
            <div className="text-center">
              <svg
                className="animate-spin h-12 w-12 mx-auto text-indigo-600"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              <p className="mt-4 text-gray-600">Loading customers...</p>
            </div>
          </div>
        ) : error ? (
          <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">
                  {typeof error === "string" ? error : error?.message || "An error occurred"}
                </p>
              </div>
            </div>
          </div>
        ) : customersList.length > 0 ? (
          <div className="overflow-x-auto shadow rounded">
            <table className="w-full text-sm text-left border-collapse">
              <thead className="border-b border-primary py-14 uppercase tracking-wider">
                <tr className="bg-gray-100">
                  <th className="py-2 px-4 border bg-primary text-white">Customer</th>
                  <th className="py-2 px-4 border bg-primary text-white">Mobile</th>
                  <th className="py-2 px-4 border bg-primary text-white">QR Code</th>
                  <th className="py-2 px-4 border bg-primary text-white">Amount</th>
                  <th className="py-2 px-4 border bg-primary text-white">City</th>
                  <th className="py-2 px-4 border bg-primary text-white">State</th>
                  <th className="py-2 px-4 border bg-primary text-white">Status</th>
                  <th className="py-2 px-4 border bg-primary text-white">Date</th>
                </tr>
              </thead>
              <tbody>
                {customersList.map((c) => (
                  <tr
                    key={c.redemption_id}
                    className="border-t bg-white border-b hover:bg-gray-50 transition"
                  >
                    <td className="py-4 px-4">{c.customer_name || "N/A"}</td>
                    <td className="py-4 px-4">{c.mobile || "N/A"}</td>
                    <td className="py-4 px-4 font-mono text-xs">{c.qr_id || "N/A"}</td>
                    <td className="py-4 px-4">₹{c.qr_amount || 0}</td>
                    <td className="py-4 px-4">{c.city || "N/A"}</td>
                    <td className="py-4 px-4">{c.state || "N/A"}</td>
                    <td className="py-2 px-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          c.is_successful
                            ? "bg-green-100 text-green-800"
                            : c.is_failed
                            ? "bg-red-100 text-red-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {c.is_successful
                          ? "Success"
                          : c.is_failed
                          ? "Failed"
                          : "Pending"}
                      </span>
                    </td>
                    <td className="py-2 px-4">
                      {c.redeemed_at ? new Date(c.redeemed_at).toLocaleString() : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-lg">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900">No customers</h3>
            <p className="mt-1 text-sm text-gray-500">
              No redeemed customers found.
            </p>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default CustomerList;